/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
    Box,
    Grid,
    MenuItem,
    FormControl,
    FormLabel,
    InputLabel,
    Select,
    FormHelperText,
    Checkbox,
    ListItemText,
    OutlinedInput,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    Typography,
    Autocomplete,
    IconButton,
    Collapse,
    Chip
} from '@mui/material';

import SubCard from 'ui-component/cards/SubCard';
import { gridSpacing, roles } from 'store/constant';
import {
    additionPetFeeDescriptionList,
    applicationRequiredList,
    leaseTermList,
    oneTimeExpensesList,
    petsAllowedList,
    recurringExpensesList
} from './data/how_to_apply_data';
import HelpIcon from './HelpIcon';
import { tips } from './HelpData';
import { Field, ErrorMessage } from 'formik';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch } from 'react-redux';
import { ListingActions } from 'store/slices/listings';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const HowToApply = ({ role, errors, handleChange, handleBlur, values, touched, setFieldValue, id }) => {
    const dispatch = useDispatch();
    const [openOptional, setOpenOptional] = React.useState(true);

    const handleToggle = () => {
        setOpenOptional((prev) => !prev);
    };

    const { createShotnerURL } = ListingActions;

    const [tinyUrlAgent, setTinyUrlAgent] = useState({});
    const [tinyUrl, setTinyUrl] = useState({});

    const handleBlurChange = () => {
        if (values.websiteAppLinkPublicView) {
            const valuesData = values.websiteAppLinkPublicView;
            dispatch(createShotnerURL({ url: valuesData, property_id: id })).then((res) => {
                if (res?.payload) {
                    setTinyUrl(res?.payload);
                }
            });
        }

        if (values.websiteAppLinkAgentView) {
            const privateUrl = values.websiteAppLinkAgentView;
            dispatch(createShotnerURL({ url: privateUrl, property_id: id })).then((res) => {
                if (res?.payload) {
                    setTinyUrlAgent(res?.payload);
                }
            });
        }
    };

    useEffect(() => {
        handleBlurChange();
    }, [values?.websiteAppLinkPublicView, values?.websiteAppLinkAgentView]);

    // console.log(tinyUrl, tinyUrlAgent);

    return (
        <>
            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <Box sx={{ mt: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            mb: 2
                                        }}
                                    >
                                        Application Information
                                    </Typography>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            {role === roles.ADMIN && (
                                                <Grid item xs={12} sm={4}>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <FormControl
                                                            fullWidth
                                                            required
                                                            error={touched.intermediaryYN && Boolean(errors.intermediaryYN)}
                                                        >
                                                            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                                <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                    <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                        Is there any Intermediary?
                                                                    </Typography>
                                                                </FormLabel>
                                                                <HelpIcon
                                                                    title={tips?.intermediaryYN.title}
                                                                    ruleHelp={tips?.intermediaryYN.ruleHelp}
                                                                    generalHelpDesc={tips?.intermediaryYN.generalHelpDesc}
                                                                />
                                                            </Box>
                                                            <RadioGroup
                                                                aria-label="listing-agreement"
                                                                name="intermediaryYN"
                                                                value={values.intermediaryYN}
                                                                onChange={handleChange}
                                                                row
                                                                sx={{ gap: 1, ml: 1, mt: 1 }}
                                                            >
                                                                <FormControlLabel
                                                                    value="YES"
                                                                    control={<Radio />}
                                                                    label="YES"
                                                                    sx={{
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '5px',
                                                                        padding: '2px 14px',
                                                                        minWidth: '140px'
                                                                    }}
                                                                />

                                                                <FormControlLabel
                                                                    value="NO"
                                                                    control={<Radio />}
                                                                    label="NO"
                                                                    sx={{
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '5px',
                                                                        padding: '2px 14px',
                                                                        minWidth: '140px'
                                                                    }}
                                                                />
                                                            </RadioGroup>
                                                            {/* <Select
                                                                value={values.intermediaryYN}
                                                                onChange={(event) => {
                                                                    setFieldValue('intermediaryYN', event.target.value);
                                                                }}
                                                                onBlur={handleBlur}
                                                                input={<OutlinedInput />}
                                                            >
                                                                <MenuItem value="YES" sx={{ my: 0.5 }}>
                                                                    <ListItemText primary="YES" />
                                                                </MenuItem>
                                                                <MenuItem value="NO" sx={{ my: 0.5 }}>
                                                                    <ListItemText primary="NO" />
                                                                </MenuItem>
                                                            </Select> */}
                                                            {touched.intermediaryYN && errors.intermediaryYN && (
                                                                <FormHelperText>{errors.intermediaryYN}</FormHelperText>
                                                            )}
                                                        </FormControl>
                                                    </Box>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Application Fee
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.applicationFee.title}
                                                        ruleHelp={tips?.applicationFee.ruleHelp}
                                                        generalHelpDesc={tips?.applicationFee.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="applicationFee"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.applicationFee}
                                                        error={touched.applicationFee && errors.applicationFee}
                                                        helperText={<ErrorMessage name="applicationFee" />}
                                                    />
                                                </Box>
                                                {/* {touched.applicationFee && errors.applicationFee && (
                                            <FormHelperText error>{errors.applicationFee}</FormHelperText>
                                        )} */}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.applicationFeePerPerson && Boolean(errors.applicationFeePerPerson)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Is there a fee per applicant/Person?
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.applicationFeePerPerson.title}
                                                                ruleHelp={tips?.applicationFeePerPerson.ruleHelp}
                                                                generalHelpDesc={tips?.applicationFeePerPerson.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="applicationFeePerPerson"
                                                            value={values.applicationFeePerPerson}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="YES"
                                                                control={<Radio />}
                                                                label="YES"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px',
                                                                    minWidth: '140px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="NO"
                                                                control={<Radio />}
                                                                label="NO"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px',
                                                                    minWidth: '140px'
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                        {/* <Select
                                                            value={values.applicationFeePerPerson}
                                                            onChange={(event) => {
                                                                setFieldValue('applicationFeePerPerson', event.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            input={<OutlinedInput />}
                                                        >
                                                            <MenuItem value="YES" sx={{ my: 0.5 }}>
                                                                <ListItemText primary="YES" />
                                                            </MenuItem>
                                                            <MenuItem value="NO" sx={{ my: 0.5 }}>
                                                                <ListItemText primary="NO" />
                                                            </MenuItem>
                                                        </Select> */}
                                                        {touched.applicationFeePerPerson && errors.applicationFeePerPerson && (
                                                            <FormHelperText>{errors.applicationFeePerPerson}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Application Fee Payable To
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.applicationFeePayableTo.title}
                                                        ruleHelp={tips?.applicationFeePayableTo.ruleHelp}
                                                        generalHelpDesc={tips?.applicationFeePayableTo.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="applicationFeePayableTo"
                                                        label=""
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.applicationFeePayableTo}
                                                        error={touched.applicationFeePayableTo && errors.applicationFeePayableTo}
                                                        helperText={<ErrorMessage name="applicationFeePayableTo" />}
                                                    />
                                                </Box>
                                                {/* {touched.applicationFeePayableTo && errors.applicationFeePayableTo && (
                                            <FormHelperText error>{errors.applicationFeePayableTo}</FormHelperText>
                                        )} */}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl fullWidth required error={touched.managedBy && Boolean(errors.managedBy)}>
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Managed By
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.managedBy.title}
                                                                ruleHelp={tips?.managedBy.ruleHelp}
                                                                generalHelpDesc={tips?.managedBy.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="managedBy"
                                                            value={values.managedBy}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="Owner"
                                                                control={<Radio />}
                                                                label="Owner"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px',
                                                                    minWidth: '140px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="Property Manager"
                                                                control={<Radio />}
                                                                label="Property Manager"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px',
                                                                    minWidth: '140px'
                                                                }}
                                                            />
                                                        </RadioGroup>
                                                        {/* <Select
                                                            label=""
                                                            value={values.managedBy}
                                                            onChange={(event) => {
                                                                setFieldValue('managedBy', event.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            input={<OutlinedInput />}
                                                        >
                                                            <MenuItem value="Owner" sx={{ my: 0.5 }}>
                                                                <ListItemText primary="Owner" />
                                                            </MenuItem>
                                                            <MenuItem value="Property Manager" sx={{ my: 0.5 }}>
                                                                <ListItemText primary="Property Manager" />
                                                            </MenuItem>
                                                        </Select> */}
                                                        {touched.managedBy && errors.managedBy && (
                                                            <FormHelperText>{errors.managedBy}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Security Deposit
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.securityDeposit.title}
                                                        ruleHelp={tips?.securityDeposit.ruleHelp}
                                                        generalHelpDesc={tips?.securityDeposit.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="securityDeposit"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.securityDeposit}
                                                        error={touched.securityDeposit && errors.securityDeposit}
                                                        helperText={<ErrorMessage name="securityDeposit" />}
                                                    />
                                                </Box>
                                                {/* {touched.securityDeposit && errors.securityDeposit && (
                                            <FormHelperText error>{errors.securityDeposit}</FormHelperText>
                                        )} */}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Security Deposit Payable To
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.securityDepositPayableTo.title}
                                                        ruleHelp={tips?.securityDepositPayableTo.ruleHelp}
                                                        generalHelpDesc={tips?.securityDepositPayableTo.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="securityDepositPayableTo"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.securityDepositPayableTo}
                                                        error={touched.securityDepositPayableTo && errors.securityDepositPayableTo}
                                                        helperText={<ErrorMessage name="securityDepositPayableTo" />}
                                                    />
                                                </Box>
                                                {/* {touched.securityDepositPayableTo && errors.securityDepositPayableTo && (
                                            <FormHelperText error>{errors.securityDepositPayableTo}</FormHelperText>
                                        )} */}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <FormControl fullWidth required error={touched.leaseTerm && Boolean(errors.leaseTerm)}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <FormLabel sx={{ mb: 1, '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Lease Term
                                                            </Typography>
                                                        </FormLabel>
                                                        <HelpIcon
                                                            title={tips?.leaseTerm.title}
                                                            ruleHelp={tips?.leaseTerm.ruleHelp}
                                                            generalHelpDesc={tips?.leaseTerm.generalHelpDesc}
                                                            generalHelp={tips?.leaseTerm.generalHelp}
                                                        />
                                                    </Box>
                                                    <Autocomplete
                                                        renderTags={(tagValue, getTagProps) =>
                                                            tagValue.map((option, index) => (
                                                                <Chip
                                                                    key={index}
                                                                    label={option}
                                                                    {...getTagProps({ index })}
                                                                    sx={{
                                                                        '& .MuiChip-deleteIcon': {
                                                                            color: 'black !important'
                                                                        }
                                                                    }}
                                                                />
                                                            ))
                                                        }
                                                        options={leaseTermList}
                                                        value={values.leaseTerm || []}
                                                        onChange={(event, newValue) => setFieldValue('leaseTerm', newValue)}
                                                        onBlur={handleBlur}
                                                        renderInput={(params) => (
                                                            <TextField {...params} error={Boolean(touched.leaseTerm && errors.leaseTerm)} />
                                                        )}
                                                        disableCloseOnSelect
                                                        renderOption={(props, option, { selected }) => (
                                                            <li {...props}>
                                                                {/* <Checkbox checked={selected} /> */}
                                                                {option}
                                                            </li>
                                                        )}
                                                    />
                                                    {touched.leaseTerm && errors.leaseTerm && (
                                                        <FormHelperText>{errors.leaseTerm}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            mb: 2
                                        }}
                                    >
                                        Administration Information
                                    </Typography>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Administration Fee
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.administrationFee.title}
                                                        ruleHelp={tips?.administrationFee.ruleHelp}
                                                        generalHelpDesc={tips?.administrationFee.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="administrationFee"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.administrationFee}
                                                        error={touched.administrationFee && errors.administrationFee}
                                                        helperText={<ErrorMessage name="administrationFee" />}
                                                    />
                                                </Box>
                                                {/* {touched.administrationFee && errors.administrationFee && (
                                            <FormHelperText error>{errors.administrationFee}</FormHelperText>
                                        )} */}
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Administration Fee Payable To
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.administrationFeePayableTo.title}
                                                        ruleHelp={tips?.administrationFeePayableTo.ruleHelp}
                                                        generalHelpDesc={tips?.administrationFeePayableTo.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="administrationFeePayableTo"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.administrationFeePayableTo}
                                                        error={touched.administrationFeePayableTo && errors.administrationFeePayableTo}
                                                        helperText={<ErrorMessage name="administrationFeePayableTo" />}
                                                    />
                                                </Box>
                                                {/* {touched.administrationFeePayableTo && errors.administrationFeePayableTo && (
                                            <FormHelperText error>{errors.administrationFeePayableTo}</FormHelperText>
                                        )} */}
                                            </Grid>

                                            <Grid item xs={12} sm={5}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.firstMonthRentPayableTo && Boolean(errors.firstMonthRentPayableTo)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    First Month Rent Payable To
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.firstMonthRentPayableTo.title}
                                                                ruleHelp={tips?.firstMonthRentPayableTo.ruleHelp}
                                                                generalHelpDesc={tips?.firstMonthRentPayableTo.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="firstMonthRentPayableTo"
                                                            value={values.firstMonthRentPayableTo}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1, display: 'flex' }}
                                                        >
                                                            <FormControlLabel
                                                                value="Owner"
                                                                control={<Radio />}
                                                                label="Owner"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="Broker"
                                                                control={<Radio />}
                                                                label="Broker"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="See Remarks"
                                                                control={<Radio />}
                                                                label="See Remarks"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />
                                                        </RadioGroup>

                                                        {touched.firstMonthRentPayableTo && errors.firstMonthRentPayableTo && (
                                                            <FormHelperText>{errors.firstMonthRentPayableTo}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.onSiteCompliance && Boolean(errors.onSiteCompliance)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Do you want On Site Compliance?
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.onSiteCompliance.title}
                                                                ruleHelp={tips?.onSiteCompliance.ruleHelp}
                                                                generalHelpDesc={tips?.onSiteCompliance.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="onSiteCompliance"
                                                            value={values.onSiteCompliance}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="YES"
                                                                control={<Radio />}
                                                                label="YES"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="NO"
                                                                control={<Radio />}
                                                                label="NO"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />
                                                        </RadioGroup>

                                                        {touched.onSiteCompliance && errors.onSiteCompliance && (
                                                            <FormHelperText>{errors.onSiteCompliance}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.renterInsuranceRequired && Boolean(errors.renterInsuranceRequired)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Renter Insurance Required
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.renterInsuranceRequired.title}
                                                                ruleHelp={tips?.renterInsuranceRequired.ruleHelp}
                                                                generalHelpDesc={tips?.renterInsuranceRequired.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="renterInsuranceRequired"
                                                            value={values.renterInsuranceRequired}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="YES"
                                                                control={<Radio />}
                                                                label="YES"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="NO"
                                                                control={<Radio />}
                                                                label="NO"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />
                                                        </RadioGroup>

                                                        {touched.renterInsuranceRequired && errors.renterInsuranceRequired && (
                                                            <FormHelperText>{errors.renterInsuranceRequired}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            mb: 2
                                        }}
                                    >
                                        Pets Information
                                    </Typography>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.petsAllowed && Boolean(errors.petsAllowed)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Pets Allowed
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.petsAllowed.title}
                                                                ruleHelp={tips?.petsAllowed.ruleHelp}
                                                                generalHelpDesc={tips?.petsAllowed.generalHelpDesc}
                                                                generalHelp={tips?.petsAllowed.generalHelp}
                                                            />
                                                        </Box>
                                                        <Autocomplete
                                                            renderTags={(tagValue, getTagProps) =>
                                                                tagValue.map((option, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={option}
                                                                        {...getTagProps({ index })}
                                                                        sx={{
                                                                            '& .MuiChip-deleteIcon': {
                                                                                color: 'black !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            multiple
                                                            options={petsAllowedList}
                                                            value={values.petsAllowed}
                                                            onChange={(event, newValue) => {
                                                                setFieldValue('petsAllowed', newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    error={touched.petsAllowed && Boolean(errors.petsAllowed)}
                                                                />
                                                            )}
                                                        />
                                                        {touched.petsAllowed && errors.petsAllowed && (
                                                            <FormHelperText>{errors.petsAllowed}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Pet Deposit
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.petDeposit.title}
                                                        ruleHelp={tips?.petDeposit.ruleHelp}
                                                        generalHelpDesc={tips?.petDeposit.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="petDeposit"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.petDeposit}
                                                        error={touched.petDeposit && errors.petDeposit}
                                                        helperText={<ErrorMessage name="petDeposit" />}
                                                    />
                                                </Box>
                                                {/* {touched.petDeposit && errors.petDeposit && (
                                            <FormHelperText error>{errors.petDeposit}</FormHelperText>
                                        )} */}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Max Number of Pets
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.maxNumberOfPets.title}
                                                        ruleHelp={tips?.maxNumberOfPets.ruleHelp}
                                                        generalHelpDesc={tips?.maxNumberOfPets.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="maxNumberOfPets"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.maxNumberOfPets}
                                                        error={touched.maxNumberOfPets && errors.maxNumberOfPets}
                                                        helperText={<ErrorMessage name="maxNumberOfPets" />}
                                                    />
                                                </Box>
                                                {/* {touched.maxNumberOfPets && errors.maxNumberOfPets && (
                                            <FormHelperText error>{errors.maxNumberOfPets}</FormHelperText>
                                        )} */}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.petDepositPerPet && Boolean(errors.petDepositPerPet)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Pet Deposit Per Pet
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.petDepositPerPet.title}
                                                                ruleHelp={tips?.petDepositPerPet.ruleHelp}
                                                                generalHelpDesc={tips?.petDepositPerPet.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <Autocomplete
                                                            renderTags={(tagValue, getTagProps) =>
                                                                tagValue.map((option, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={option}
                                                                        {...getTagProps({ index })}
                                                                        sx={{
                                                                            '& .MuiChip-deleteIcon': {
                                                                                color: 'black !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            options={['YES', 'NO']} // Options for pet deposit
                                                            value={values.petDepositPerPet ? values.petDepositPerPet : null} // Handle value as string
                                                            onChange={(event, newValue) => {
                                                                setFieldValue('petDepositPerPet', newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    error={touched.petDepositPerPet && Boolean(errors.petDepositPerPet)}
                                                                />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option === value} // Compare options as strings
                                                        />
                                                        {touched.petDepositPerPet && errors.petDepositPerPet && (
                                                            <FormHelperText>{errors.petDepositPerPet}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Monthly Pet Rent
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.monthlyPetRent.title}
                                                        ruleHelp={tips?.monthlyPetRent.ruleHelp}
                                                        generalHelpDesc={tips?.monthlyPetRent.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="monthlyPetRent"
                                                        label=""
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.monthlyPetRent}
                                                        error={touched.monthlyPetRent && errors.monthlyPetRent}
                                                        helperText={<ErrorMessage name="monthlyPetRent" />}
                                                    />
                                                </Box>
                                                {/* {touched.monthlyPetRent && errors.monthlyPetRent && (
                                            <FormHelperText error>{errors.monthlyPetRent}</FormHelperText>
                                        )} */}
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.monthlyPetRentPerPet && Boolean(errors.monthlyPetRentPerPet)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Monthly Pet Rent Per Pet
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.monthlyPetRentPerPet.title}
                                                                ruleHelp={tips?.monthlyPetRentPerPet.ruleHelp}
                                                                generalHelpDesc={tips?.monthlyPetRentPerPet.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="monthlyPetRentPerPet"
                                                            value={values.monthlyPetRentPerPet}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="YES"
                                                                control={<Radio />}
                                                                label="YES"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="NO"
                                                                control={<Radio />}
                                                                label="NO"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px',
                                                                    justifyContent: 'center'
                                                                }}
                                                            />
                                                        </RadioGroup>

                                                        {touched.monthlyPetRentPerPet && errors.monthlyPetRentPerPet && (
                                                            <FormHelperText>{errors.monthlyPetRentPerPet}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Additional Pet Fee
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.additionalPetFee.title}
                                                        ruleHelp={tips?.additionalPetFee.ruleHelp}
                                                        generalHelpDesc={tips?.additionalPetFee.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="additionalPetFee"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.additionalPetFee}
                                                        error={touched.additionalPetFee && errors.additionalPetFee}
                                                        helperText={<ErrorMessage name="additionalPetFee" />}
                                                    />
                                                </Box>
                                                {/* {touched.additionalPetFee && errors.additionalPetFee && (
                                            <FormHelperText error>{errors.additionalPetFee}</FormHelperText>
                                        )} */}
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={
                                                            touched.additionPetFeeDescription && Boolean(errors.additionPetFeeDescription)
                                                        }
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Additional Pet Fee Description
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.additionPetFeeDescription.title}
                                                                ruleHelp={tips?.additionPetFeeDescription.ruleHelp}
                                                                generalHelpDesc={tips?.additionPetFeeDescription.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <Autocomplete
                                                            renderTags={(tagValue, getTagProps) =>
                                                                tagValue.map((option, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={option}
                                                                        {...getTagProps({ index })}
                                                                        sx={{
                                                                            '& .MuiChip-deleteIcon': {
                                                                                color: 'black !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            options={additionPetFeeDescriptionList} // Options for additional pet fee descriptions
                                                            value={values.additionPetFeeDescription || null} // Handle value as string
                                                            onChange={(event, newValue) => {
                                                                setFieldValue('additionPetFeeDescription', newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    error={
                                                                        touched.additionPetFeeDescription &&
                                                                        Boolean(errors.additionPetFeeDescription)
                                                                    }
                                                                />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option === value} // Compare options as strings
                                                        />
                                                        {touched.additionPetFeeDescription && errors.additionPetFeeDescription && (
                                                            <FormHelperText>{errors.additionPetFeeDescription}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            mb: 2
                                        }}
                                    >
                                        Lease Information
                                    </Typography>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Available Date
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.availableDate.title}
                                                        ruleHelp={tips?.availableDate.ruleHelp}
                                                        generalHelpDesc={tips?.availableDate.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <DatePicker
                                                        required
                                                        label=""
                                                        value={values.availableDate}
                                                        onChange={(newValue) => {
                                                            setFieldValue('availableDate', newValue);
                                                        }}
                                                        sx={{ width: '100%' }}
                                                        onBlur={handleBlur}
                                                        slotProps={{
                                                            textField: {
                                                                variant: 'outlined',
                                                                error: Boolean(touched.availableDate && errors.availableDate),
                                                                helperText:
                                                                    touched.availableDate && errors.availableDate
                                                                        ? 'Available Date is Required'
                                                                        : ''
                                                            }
                                                        }}
                                                    />
                                                    {/* <Field
                                                as={TextField}
                                                fullWidth
                                                required
                                                type="date"
                                                name="availableDate"
                                                label={values.availableDate ? '' : ''}
                                                variant="outlined"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.availableDate}
                                                error={touched.availableDate && errors.availableDate}
                                                helperText={<ErrorMessage name="availableDate" />}
                                            /> */}
                                                </Box>
                                                {/* {touched.availableDate && errors.availableDate && (
                                            <FormHelperText error>{errors.availableDate}</FormHelperText>
                                        )} */}
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.certifiedFunds && Boolean(errors.certifiedFunds)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Certified Funds
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.certifiedFunds.title}
                                                                ruleHelp={tips?.certifiedFunds.ruleHelp}
                                                                generalHelpDesc={tips?.certifiedFunds.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="certifiedFunds"
                                                            value={values.certifiedFunds}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="YES"
                                                                control={<Radio />}
                                                                label="YES"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="NO"
                                                                control={<Radio />}
                                                                label="NO"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />
                                                        </RadioGroup>

                                                        {touched.certifiedFunds && errors.certifiedFunds && (
                                                            <FormHelperText>{errors.certifiedFunds}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.leaseGuarantorYN && Boolean(errors.leaseGuarantorYN)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Lease Guarantor Y/N
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.leaseGuarantorYN.title}
                                                                ruleHelp={tips?.leaseGuarantorYN.ruleHelp}
                                                                generalHelpDesc={tips?.leaseGuarantorYN.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="leaseGuarantorYN"
                                                            value={values.leaseGuarantorYN}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="YES"
                                                                control={<Radio />}
                                                                label="YES"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="NO"
                                                                control={<Radio />}
                                                                label="NO"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px',
                                                                    justifyContent: 'center'
                                                                }}
                                                            />
                                                        </RadioGroup>

                                                        {touched.leaseGuarantorYN && errors.leaseGuarantorYN && (
                                                            <FormHelperText>{errors.leaseGuarantorYN}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.petDepositPerPet && Boolean(errors.petDepositPerPet)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Pet Deposit Per Pet
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.petDepositPerPet.title}
                                                                ruleHelp={tips?.petDepositPerPet.ruleHelp}
                                                                generalHelpDesc={tips?.petDepositPerPet.generalHelpDesc}
                                                            />
                                                        </Box>

                                                        <Autocomplete
                                                            renderTags={(tagValue, getTagProps) =>
                                                                tagValue.map((option, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={option}
                                                                        {...getTagProps({ index })}
                                                                        sx={{
                                                                            '& .MuiChip-deleteIcon': {
                                                                                color: 'black !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            options={['YES', 'NO']} // Options for pet deposit
                                                            value={values.petDepositPerPet || null} // Handle value as string
                                                            onChange={(event, newValue) => {
                                                                setFieldValue('petDepositPerPet', newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    id="petDepositPerPet"
                                                                    name="petDepositPerPet"
                                                                    variant="outlined"
                                                                    error={touched.petDepositPerPet && Boolean(errors.petDepositPerPet)}
                                                                />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option === value} // Compare options as strings
                                                        />
                                                        {touched.petDepositPerPet && errors.petDepositPerPet && (
                                                            <FormHelperText>{errors.petDepositPerPet}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Application Policy
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.applicationPolicy.title}
                                                        ruleHelp={tips?.applicationPolicy.ruleHelp}
                                                        generalHelpDesc={tips?.applicationPolicy.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.applicationPolicy && Boolean(errors.applicationPolicy)}
                                                    >
                                                        <Select
                                                            value={values.applicationPolicy}
                                                            onChange={(event) => {
                                                                setFieldValue('applicationPolicy', event.target.value);
                                                            }}
                                                            onBlur={handleBlur}
                                                            input={<OutlinedInput />}
                                                        >
                                                            <MenuItem value="Best Qualified Application" sx={{ my: 0.5 }}>
                                                                <ListItemText primary="Best Qualified Application" />
                                                            </MenuItem>
                                                            <MenuItem value="First Qualified Application" sx={{ my: 0.5 }}>
                                                                <ListItemText primary="First Qualified Application" />
                                                            </MenuItem>
                                                        </Select>
                                                        {touched.applicationPolicy && errors.applicationPolicy && (
                                                            <FormHelperText>{errors.applicationPolicy}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            mb: 2
                                        }}
                                    >
                                        Locator Commissions Information
                                    </Typography>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.sellerContributionsYN && Boolean(errors.sellerContributionsYN)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Owner contributions Y/N (Locator Commissions)
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.sellerContributionsYN.title}
                                                                ruleHelp={tips?.sellerContributionsYN.ruleHelp}
                                                                generalHelpDesc={tips?.sellerContributionsYN.generalHelpDesc}
                                                                generalHelp={tips?.sellerContributionsYN.generalHelp}
                                                            />
                                                        </Box>
                                                        <RadioGroup
                                                            name="sellerContributionsYN"
                                                            value={values.sellerContributionsYN}
                                                            onChange={handleChange}
                                                            row
                                                            sx={{ gap: 1, ml: 1, mt: 1 }}
                                                        >
                                                            <FormControlLabel
                                                                value="YES"
                                                                control={<Radio />}
                                                                label="YES"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />

                                                            <FormControlLabel
                                                                value="NO"
                                                                control={<Radio />}
                                                                label="NO"
                                                                sx={{
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '5px',
                                                                    padding: '2px 14px'
                                                                }}
                                                            />
                                                        </RadioGroup>

                                                        {touched.sellerContributionsYN && errors.sellerContributionsYN && (
                                                            <FormHelperText>{errors.sellerContributionsYN}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <FormControl required>
                                                    <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                        <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                            <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                Commission Type
                                                            </Typography>
                                                        </FormLabel>
                                                    </Box>
                                                    <RadioGroup
                                                        aria-labelledby="commissionType"
                                                        name="commissionType"
                                                        value={values.commissionType}
                                                        onChange={(event) => setFieldValue('commissionType', event.target.value)}
                                                    >
                                                        <FormControlLabel value="percentage" control={<Radio />} label="Percentage" />
                                                        <FormControlLabel value="dollar" control={<Radio />} label="Dollar" />
                                                    </RadioGroup>
                                                </FormControl>
                                                {errors.commissionType && touched.commissionType && (
                                                    <FormHelperText error>{errors.commissionType}</FormHelperText>
                                                )}
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            {values.commissionType === 'percentage' ? 'Percentage' : 'Dollar Amount'}
                                                        </Typography>
                                                    </FormLabel>
                                                </Box>
                                                <Field
                                                    as={TextField}
                                                    fullWidth
                                                    required
                                                    type="number"
                                                    name="commission"
                                                    variant="outlined"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.commission}
                                                    error={touched.commission && errors.commission}
                                                    helperText={<ErrorMessage name="commission" />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography
                                        sx={{
                                            color: '#919191',
                                            fontSize: '16px',
                                            fontStyle: 'normal',
                                            fontWeight: '700',
                                            lineHeight: 'normal',
                                            textTransform: 'capitalize',
                                            mb: 2
                                        }}
                                    >
                                        Additional Information
                                    </Typography>
                                    <SubCard>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.applicationRequired && Boolean(errors.applicationRequired)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    Application Required
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.applicationRequired.title}
                                                                ruleHelp={tips?.applicationRequired.ruleHelp}
                                                                generalHelpDesc={tips?.applicationRequired.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <Autocomplete
                                                            renderTags={(tagValue, getTagProps) =>
                                                                tagValue.map((option, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={option}
                                                                        {...getTagProps({ index })}
                                                                        sx={{
                                                                            '& .MuiChip-deleteIcon': {
                                                                                color: 'black !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            multiple
                                                            options={applicationRequiredList}
                                                            value={values.applicationRequired || []}
                                                            onChange={(event, newValue) => {
                                                                setFieldValue('applicationRequired', newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    error={
                                                                        touched.applicationRequired && Boolean(errors.applicationRequired)
                                                                    }
                                                                />
                                                            )}
                                                            disableCloseOnSelect
                                                            renderOption={(props, option, { selected }) => (
                                                                <li {...props}>
                                                                    <Checkbox checked={selected} />
                                                                    <ListItemText primary={option} />
                                                                </li>
                                                            )}
                                                        />
                                                        {touched.applicationRequired && errors.applicationRequired && (
                                                            <FormHelperText>{errors.applicationRequired}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={touched.oneTimeExpenses && Boolean(errors.oneTimeExpenses)}
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    One Time Expenses
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.oneTimeExpenses.title}
                                                                ruleHelp={tips?.oneTimeExpenses.ruleHelp}
                                                                generalHelpDesc={tips?.oneTimeExpenses.generalHelpDesc}
                                                            />
                                                        </Box>
                                                        <Autocomplete
                                                            renderTags={(tagValue, getTagProps) =>
                                                                tagValue.map((option, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={option}
                                                                        {...getTagProps({ index })}
                                                                        sx={{
                                                                            '& .MuiChip-deleteIcon': {
                                                                                color: 'black !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            multiple
                                                            options={oneTimeExpensesList}
                                                            value={values.oneTimeExpenses || []}
                                                            onChange={(event, newValue) => {
                                                                setFieldValue('oneTimeExpenses', newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    error={touched.oneTimeExpenses && Boolean(errors.oneTimeExpenses)}
                                                                />
                                                            )}
                                                            disableCloseOnSelect
                                                            renderOption={(props, option, { selected }) => (
                                                                <li {...props}>
                                                                    <Checkbox checked={selected} />
                                                                    <ListItemText primary={option} />
                                                                </li>
                                                            )}
                                                        />
                                                        {touched.oneTimeExpenses && errors.oneTimeExpenses && (
                                                            <FormHelperText>{errors.oneTimeExpenses}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ display: 'flex' }}>
                                                    <FormControl
                                                        fullWidth
                                                        required
                                                        error={
                                                            touched.rentSpreeOnlineApplicationYN &&
                                                            Boolean(errors.rentSpreeOnlineApplicationYN)
                                                        }
                                                    >
                                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                                    RentSpree Online Application Y/N
                                                                </Typography>
                                                            </FormLabel>
                                                            <HelpIcon
                                                                title={tips?.rentSpreeOnlineApplicationYN.title}
                                                                ruleHelp={tips?.rentSpreeOnlineApplicationYN.ruleHelp}
                                                                generalHelpDesc={tips?.rentSpreeOnlineApplicationYN.generalHelpDesc}
                                                                generalHelp={tips?.rentSpreeOnlineApplicationYN.generalHelp}
                                                            />
                                                        </Box>
                                                        <Autocomplete
                                                            renderTags={(tagValue, getTagProps) =>
                                                                tagValue.map((option, index) => (
                                                                    <Chip
                                                                        key={index}
                                                                        label={option}
                                                                        {...getTagProps({ index })}
                                                                        sx={{
                                                                            '& .MuiChip-deleteIcon': {
                                                                                color: 'black !important'
                                                                            }
                                                                        }}
                                                                    />
                                                                ))
                                                            }
                                                            options={['YES', 'NO']}
                                                            value={values.rentSpreeOnlineApplicationYN || null}
                                                            onChange={(event, newValue) => {
                                                                setFieldValue('rentSpreeOnlineApplicationYN', newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    error={
                                                                        touched.rentSpreeOnlineApplicationYN &&
                                                                        Boolean(errors.rentSpreeOnlineApplicationYN)
                                                                    }
                                                                />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => option === value}
                                                        />
                                                        {touched.rentSpreeOnlineApplicationYN && errors.rentSpreeOnlineApplicationYN && (
                                                            <FormHelperText>{errors.rentSpreeOnlineApplicationYN}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Application Deliver Address
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.applicationDeliverAddress.title}
                                                        ruleHelp={tips?.applicationDeliverAddress.ruleHelp}
                                                        generalHelpDesc={tips?.applicationDeliverAddress.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="applicationDeliverAddress"
                                                        variant="outlined"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.applicationDeliverAddress}
                                                        error={touched.applicationDeliverAddress && errors.applicationDeliverAddress}
                                                        helperText={<ErrorMessage name="applicationDeliverAddress" />}
                                                    />
                                                </Box>
                                                {/* {touched.applicationDeliverAddress && errors.applicationDeliverAddress && (
                                            <FormHelperText error>{errors.applicationDeliverAddress}</FormHelperText>
                                        )} */}
                                            </Grid>

                                            <Grid item xs={12} sm={12}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }} required>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Website App Link/Public View
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.websiteAppLinkPublicView.title}
                                                        ruleHelp={tips?.websiteAppLinkPublicView.ruleHelp}
                                                        generalHelpDesc={tips?.websiteAppLinkPublicView.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Field
                                                        as={TextField}
                                                        fullWidth
                                                        required
                                                        name="websiteAppLinkPublicView"
                                                        variant="outlined"
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            if (value) {
                                                                if (value.startsWith('http://')) {
                                                                    value = value.replace('http://', 'https://');
                                                                } else if (!value.startsWith('https://')) {
                                                                    value = `https://${value}`;
                                                                }
                                                            }
                                                            setFieldValue('websiteAppLinkPublicView', value);
                                                        }}
                                                        onBlur={handleBlur}
                                                        value={values.websiteAppLinkPublicView}
                                                        error={touched.websiteAppLinkPublicView && errors.websiteAppLinkPublicView}
                                                        helperText={<ErrorMessage name="websiteAppLinkPublicView" />}
                                                    />
                                                </Box>
                                                {tinyUrl?.id && (
                                                    <Typography variant="caption" color="textSecondary" sx={{ m: 1 }}>
                                                        {`Shotern Link for Website App Link Public View: \nhttps://mlsapartments.com/r?id=${tinyUrl?.id}`}
                                                    </Typography>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                cursor: 'pointer',
                                mb: 2,
                                p: 1,
                                background: 'white'
                            }}
                            onClick={handleToggle}
                        >
                            <Typography
                                sx={{
                                    color: '#919191',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    textTransform: 'capitalize'
                                }}
                            >
                                Optional Information
                            </Typography>
                            <IconButton>{openOptional ? <ExpandLess /> : <ExpandMore />}</IconButton>
                        </Box>

                        <Collapse in={openOptional}>
                            <SubCard sx={{ pt: '20px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControl fullWidth error={touched.associationYN && Boolean(errors.associationYN)}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Association Y/N
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.associationYN.title}
                                                        ruleHelp={tips?.associationYN.ruleHelp}
                                                        generalHelpDesc={tips?.associationYN.generalHelpDesc}
                                                    />
                                                </Box>

                                                <Select
                                                    value={values.associationYN}
                                                    onChange={(event) => {
                                                        setFieldValue('associationYN', event.target.value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    input={<OutlinedInput />}
                                                >
                                                    <MenuItem value="YES" sx={{ my: 0.5 }}>
                                                        <ListItemText primary="YES" />
                                                    </MenuItem>
                                                    <MenuItem value="NO" sx={{ my: 0.5 }}>
                                                        <ListItemText primary="NO" />
                                                    </MenuItem>
                                                </Select>
                                                {touched.associationYN && errors.associationYN && (
                                                    <FormHelperText>{errors.associationYN}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex' }}>
                                            <FormControl fullWidth error={touched.shortTermPremium && Boolean(errors.shortTermPremium)}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Short Term Premium
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.shortTermPremium.title}
                                                        ruleHelp={tips?.shortTermPremium.ruleHelp}
                                                        generalHelpDesc={tips?.shortTermPremium.generalHelpDesc}
                                                    />
                                                </Box>

                                                <Select
                                                    value={values.shortTermPremium}
                                                    onChange={(event) => {
                                                        setFieldValue('shortTermPremium', event.target.value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    input={<OutlinedInput />}
                                                >
                                                    <MenuItem value="YES" sx={{ my: 0.5 }}>
                                                        <ListItemText primary="YES" />
                                                    </MenuItem>
                                                    <MenuItem value="NO" sx={{ my: 0.5 }}>
                                                        <ListItemText primary="NO" />
                                                    </MenuItem>
                                                </Select>
                                                {touched.shortTermPremium && errors.shortTermPremium && (
                                                    <FormHelperText>{errors.shortTermPremium}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Short Term Premium Amount
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.shortTermPremiumAmount.title}
                                                ruleHelp={tips?.shortTermPremiumAmount.ruleHelp}
                                                generalHelpDesc={tips?.shortTermPremiumAmount.generalHelpDesc}
                                            />
                                        </Box>
                                        <Box sx={{ display: 'flex' }}>
                                            <TextField
                                                fullWidth
                                                name="shortTermPremiumAmount"
                                                value={values.shortTermPremiumAmount}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </Box>
                                        {touched.shortTermPremiumAmount && errors.shortTermPremiumAmount && (
                                            <FormHelperText error>{errors.shortTermPremiumAmount}</FormHelperText>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Minimum Lease Months
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.minimumLeaseMonths.title}
                                                ruleHelp={tips?.minimumLeaseMonths.ruleHelp}
                                                generalHelpDesc={tips?.minimumLeaseMonths.generalHelpDesc}
                                            />
                                        </Box>
                                        <Box sx={{ display: 'flex' }}>
                                            <TextField
                                                fullWidth
                                                name="minimumLeaseMonths"
                                                value={values.minimumLeaseMonths}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </Box>
                                        {touched.minimumLeaseMonths && errors.minimumLeaseMonths && (
                                            <FormHelperText error>{errors.minimumLeaseMonths}</FormHelperText>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Maximum Lease Months
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.maximumLeaseMonths.title}
                                                ruleHelp={tips?.maximumLeaseMonths.ruleHelp}
                                                generalHelpDesc={tips?.maximumLeaseMonths.generalHelpDesc}
                                            />
                                        </Box>
                                        <Box sx={{ display: 'flex' }}>
                                            <TextField
                                                fullWidth
                                                name="maximumLeaseMonths"
                                                value={values.maximumLeaseMonths}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </Box>
                                        {touched.maximumLeaseMonths && errors.maximumLeaseMonths && (
                                            <FormHelperText error>{errors.maximumLeaseMonths}</FormHelperText>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box sx={{ display: 'flex' }}>
                                            <FormControl fullWidth error={touched.recurringExpenses && Boolean(errors.recurringExpenses)}>
                                                <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                                    <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                        <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                            Recurring Expenses
                                                        </Typography>
                                                    </FormLabel>
                                                    <HelpIcon
                                                        title={tips?.recurringExpenses.title}
                                                        ruleHelp={tips?.recurringExpenses.ruleHelp}
                                                        generalHelpDesc={tips?.recurringExpenses.generalHelpDesc}
                                                    />
                                                </Box>
                                                <Autocomplete
                                                    renderTags={(tagValue, getTagProps) =>
                                                        tagValue.map((option, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={option}
                                                                {...getTagProps({ index })}
                                                                sx={{
                                                                    '& .MuiChip-deleteIcon': {
                                                                        color: 'black !important'
                                                                    }
                                                                }}
                                                            />
                                                        ))
                                                    }
                                                    multiple
                                                    options={recurringExpensesList}
                                                    value={values.recurringExpenses || []}
                                                    onChange={(event, newValue) => {
                                                        setFieldValue('recurringExpenses', newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            error={touched.recurringExpenses && Boolean(errors.recurringExpenses)}
                                                        />
                                                    )}
                                                    disableCloseOnSelect
                                                    renderOption={(props, option, { selected }) => (
                                                        <li {...props}>
                                                            <Checkbox checked={selected} />
                                                            <ListItemText primary={option} />
                                                        </li>
                                                    )}
                                                    renderValue={(selected) => selected.join(', ')} // Show selected values
                                                />
                                                {touched.recurringExpenses && errors.recurringExpenses && (
                                                    <FormHelperText>{errors.recurringExpenses}</FormHelperText>
                                                )}
                                            </FormControl>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                                            <FormLabel sx={{ '& .MuiFormLabel-asterisk': { color: 'red' } }}>
                                                <Typography variant="subtitle1" fontWeight="bold" component="span">
                                                    Website App Link/Agent View
                                                </Typography>
                                            </FormLabel>
                                            <HelpIcon
                                                title={tips?.websiteAppLinkAgentView.title}
                                                ruleHelp={tips?.websiteAppLinkAgentView.ruleHelp}
                                                generalHelpDesc={tips?.websiteAppLinkAgentView.generalHelpDesc}
                                            />
                                        </Box>
                                        <Box sx={{ display: 'flex' }}>
                                            <TextField
                                                fullWidth
                                                label=""
                                                name="websiteAppLinkAgentView"
                                                value={values.websiteAppLinkAgentView}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (value) {
                                                        if (value.startsWith('http://')) {
                                                            value = value.replace('http://', 'https://');
                                                        } else if (!value.startsWith('https://')) {
                                                            value = `https://${value}`;
                                                        }
                                                    }
                                                    setFieldValue('websiteAppLinkAgentView', value);
                                                }}
                                                onBlur={handleBlur}
                                            />
                                        </Box>
                                        {touched.websiteAppLinkAgentView && errors.websiteAppLinkAgentView && (
                                            <FormHelperText error>{errors.websiteAppLinkAgentView}</FormHelperText>
                                        )}
                                        {tinyUrlAgent?.id && (
                                            <Typography variant="caption" color="textSecondary" sx={{ m: 1 }}>
                                                {`Shotern Link for Website App Link Agent View: \nhttps://mlsapartments.com/r?id=${tinyUrlAgent?.id}`}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Collapse>
                    </Grid>

                    {errors.submit && (
                        <Grid item xs={12}>
                            <FormHelperText error>{errors.submit}</FormHelperText>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default HowToApply;
